import { useEffect, useState } from "react";
import { findAllWeavingAlertWithQuantitiesEvent } from "../../_events/weaving_alert/find.event";
import { message } from "antd";

export const useWeavingAlertsQuantities = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const loadData = () => {
        setLoading(true);
        findAllWeavingAlertWithQuantitiesEvent()
        .then(json => {
            setData(json.list);
            setLoading(false);
        })
        .catch(error => {
            message.error(error.message);
            setLoading(false);
        });
    }

    useEffect(() => {
        loadData();
    }, []);

    return{
        data,
        loading,
        loadData,
    };
}